<template>
  <router-view />
</template>

<script>
export default {
  name: 'CRMIndex'
}
</script>
